import {
  getMockApiReturnFromVariants,
  getMockApiReturnFromHandles,
  getMockCartApiReturn,
  getMockFidelityCouponsApi,
} from './mocks';
import { updateDataLayer } from './utils/dataLayer';

export const getVPMetadata = (() => {
  return window.__ozjs || {};
})();

const TEST_MODE = window?.__ozjs?.privateSales?.testMode || false;

const API_URL = getVPMetadata?.privateSales?.url;
const USER_ID = getVPMetadata?.customerId;

// --- API Request URLS ---

const getPricesAPIRequestURL = (shopName) => {
  return API_URL ? `${API_URL}/theoz/vp/prices?shop=${shopName}` : '';
};

const getFidelityCouponsAPIRequestURL = (shopName) => {
  return API_URL && USER_ID
    ? `${API_URL}/theoz/fid/coupons?shop=${shopName}&userId=${USER_ID}`
    : '';
};

const getCartAPIRequestURL = (shopName) => {
  return API_URL ? `${API_URL}/theoz/vp/v2/cart?shop=${shopName}` : '';
};

const getDraftOrderAPIRequestURL = (shopName) => {
  return API_URL ? `${API_URL}/theoz/vp/order?shop=${shopName}` : '';
};

function populateCartErrorMessage() {
  $('.vp-error-message').remove('');
  $('.vp-error-message').append(
    '<b class="vp-error-msg" style="display: block; padding: 20px 0;">Nous rencontrons des problèmes avec les ventes privées. Veuillez contacter notre service client si le problème persiste.</b>',
  );
}

// --- API Requests ---

/*
 * Returns request body with appropriate handles / product variants
 * By default it takes handles as param
 */
export function getRequestBody(
  properties,
  hasVariants,
  hasHandles,
  hasLineItems = false,
  coupons = [],
  fidelityCoupon = '',
) {
  if (properties && properties.length) {
    return {
      user_id: getVPMetadata && getVPMetadata.customerId,
      date: new Date().toISOString(),
      ...(coupons?.length && { discount_code: coupons }),
      ...(fidelityCoupon && { fidelity_code: [fidelityCoupon] }),
      ...(hasHandles && { products_handle: properties }),
      ...(hasVariants && { variants_id: properties }),
      ...(hasLineItems && { line_items: properties }),
    };
  }
}

export function createDraftOrder(body, shopName, successCb) {
  $.ajax({
    type: 'POST',
    url: getDraftOrderAPIRequestURL(shopName),
    data: JSON.stringify(body),
    success: successCb,
    error: populateCartErrorMessage,
  });
}

export function getNewPrices(body, shopName, cb) {
  $.ajax({
    type: 'POST',
    url: getPricesAPIRequestURL(shopName),
    data: JSON.stringify(body),
    success: [cb, updateDataLayer],
  });
}

export function getFidelityCoupons(shopName, cb) {
  $.ajax({
    type: 'GET',
    url: getFidelityCouponsAPIRequestURL(shopName),
    success: cb,
  });
}

export function getCartPromotions(body, shopName, successCb) {
  $.ajax({
    type: 'POST',
    url: getCartAPIRequestURL(shopName),
    data: JSON.stringify(body),
    success: [successCb, updateDataLayer],
    error: populateCartErrorMessage,
  });
}

// --- Get data and populate it ---

export function getPricesAndPopulate(cb, shopName, productReferences, isHandle) {
  const uniqueProdRef = [...new Set(productReferences)];

  if (!TEST_MODE) {
    const body = getRequestBody(uniqueProdRef, !isHandle, isHandle);
    if (body) getNewPrices(body, shopName, cb);
  } else {
    let mockData;
    if (isHandle) {
      mockData = getMockApiReturnFromHandles(uniqueProdRef);
    } else {
      mockData = getMockApiReturnFromVariants(uniqueProdRef);
    }
    cb(mockData);
    // update vp data layer with mock data as well
    updateDataLayer(mockData);
  }
}

export function getFidelityCouponsAndPopulate(cb, shopName) {
  if (!TEST_MODE) {
    getFidelityCoupons(shopName, cb);
  } else {
    cb(getMockFidelityCouponsApi());
  }
}

export function getCartPromotionsAndPopulate(cb, shopName, lineItems, coupons, fidelityCoupons) {
  const body = getRequestBody(lineItems, false, false, true, coupons, fidelityCoupons);
  if (!TEST_MODE) {
    if (body) getCartPromotions(body, shopName, cb);
  } else {
    const mockData = getMockCartApiReturn(lineItems, coupons);
    cb(mockData);
    // update vp data layer with mock data as well
    updateDataLayer(mockData);
  }
}
